"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTPAParams = exports.generateTPAParamsFromStyleParams = void 0;
var tpa_settings_1 = require("@wix/tpa-settings");
var utils_1 = require("./utils/utils");
var wixStyleFontUtils_1 = require("./utils/wixStyleFontUtils");
var wixStylesColorUtils_1 = require("./utils/wixStylesColorUtils");
var constants_1 = require("./constants");
var cloneStyleParams = function (styleParams) {
    return __assign(__assign({}, styleParams), { numbers: __assign({}, styleParams.numbers), booleans: __assign({}, styleParams.booleans), fonts: __assign({}, styleParams.fonts), colors: __assign({}, styleParams.colors), strings: __assign({}, styleParams.strings) });
};
function overrideStyleParamsWithDefaults(styles, defaults, options) {
    var _a;
    var styleParams = cloneStyleParams(styles.styleParams);
    if (!defaults) {
        return styleParams;
    }
    var getParam = (0, tpa_settings_1.createStyleParamGetter)({
        storage: styleParams,
        colors: styles.siteColors,
        textPresets: styles.siteTextPresets,
        isRTL: options.isRTL,
        isEditorX: options.isEditorX,
        dimensions: options.dimensions,
        isMobile: options.isMobile,
        styleParamsPerBreakpointMode: options.usesCssPerBreakpoint,
    });
    var styleParamsMap = (_a = {},
        _a[tpa_settings_1.StyleParamType.Number] = styleParams.numbers,
        _a[tpa_settings_1.StyleParamType.Boolean] = styleParams.booleans,
        _a[tpa_settings_1.StyleParamType.Font] = styleParams.fonts,
        _a[tpa_settings_1.StyleParamType.Color] = styleParams.colors,
        _a[tpa_settings_1.StyleParamType.String] = styleParams.strings,
        _a);
    Object.keys(defaults).forEach(function (styleKey) {
        var styleParam = defaults[styleKey];
        // tslint:disable-next-line:deprecation
        var keyWithoutTraits = styleParam.key || styleParam.name;
        var value = getParam(styleParam);
        if (typeof value !== 'undefined' && keyWithoutTraits) {
            var targetStylesMap = styleParamsMap[styleParam.type];
            targetStylesMap[keyWithoutTraits] = value;
        }
    });
    return styleParams;
}
function generateTPAParamsFromStyleParams(styleParams, siteColors, siteTextPresets, options) {
    var _a;
    var _b;
    if (options === void 0) { options = {}; }
    var colorStyles = styleParams.colors;
    var fontStyles = (0, utils_1.pickBy)(styleParams.fonts, wixStyleFontUtils_1.wixStylesFontUtils.isValidFontParam);
    var numbers = styleParams.numbers || {};
    var colors = wixStylesColorUtils_1.wixStylesColorUtils.getFullColorStyles({ colorStyles: colorStyles, siteColors: siteColors }) || {};
    var fonts = wixStyleFontUtils_1.wixStylesFontUtils.getFullFontStyles({ fontStyles: fontStyles, siteTextPresets: siteTextPresets }) || {};
    var strings = __assign(__assign({}, (0, utils_1.pickBy)(styleParams.fonts, wixStyleFontUtils_1.wixStylesFontUtils.isStringHack)), ((_b = styleParams.strings) !== null && _b !== void 0 ? _b : {}));
    var booleans = __assign(__assign({}, styleParams.booleans), (_a = {}, _a[constants_1.IS_RTL_PARAM] = options.isRTL, _a));
    return { colors: colors, fonts: fonts, numbers: numbers, strings: strings, booleans: booleans };
}
exports.generateTPAParamsFromStyleParams = generateTPAParamsFromStyleParams;
function generateTPAParams(siteColors, siteTextPresets, styleParams, options, defaults) {
    var styleParamsWithDefaults = overrideStyleParamsWithDefaults({
        styleParams: styleParams,
        siteColors: siteColors,
        siteTextPresets: siteTextPresets,
    }, defaults, options);
    return generateTPAParamsFromStyleParams(styleParamsWithDefaults, siteColors, siteTextPresets, options);
}
exports.generateTPAParams = generateTPAParams;
//# sourceMappingURL=generateTPAParams.js.map